/*
 * @Author: caiqin.xie
 * @since: 2023-08-14 19:23:26
 * @lastTime: 2023-11-15 16:48:21
 * @LastEditors: caiqin.xie
 * @message: 服务支持主页-产品支持组件
 */
import React from "react";
import styles from "../../index.module.scss";
import LazyMedia from "@/components/LazyMedia"
import { IProduct } from "@/common/types";
import loadable from 'react-loadable'
import NoSSR from 'react-no-ssr';

const CustomSwiper = loadable({
  loader: () => import('@/components/CustomSwiper'),
  loading: () => <div></div>,
})

interface IProps {
  ctry: string;
  words: Record<string, string>;
  productList: IProduct[]; // 产品列表
}

const ProductSupport = (props:IProps) => {
  const {ctry, words, productList} = props
  return (
    <>
      {productList && productList.length > 0 &&  (
        <section className={`${styles["support-product"]} ${styles["support-section"]}`}>
          <h2>
            {words.support_home_product_title}
            {/* Product support */}
          </h2>
          <NoSSR>
            <CustomSwiper
              swiperWrapClass={styles['custom-swiper-wrap']}
              swiperSlideClass={styles['custom-swiper-slider']}>
              {productList.map(item => (
                <a
                  key={item.id}
                  href={`/${ctry}/support/product-support/${item.name}`}
                  className={styles["product-item"]}>
                  <LazyMedia type="image" LazyClassName={styles["product-img-lazy"]} className={styles["product-img"]} src={item.cover} alt={item.coverAlt} />
                  <div className={styles['product-info']}>
                    <h3 className={styles['product-title']}>{item.name}</h3>
                    <p className={styles['product-desc']}>{item.briefIntroduction}</p>
                  </div>
                </a>
              ))}
            </CustomSwiper>
          </NoSSR>

          {/* 暂时注释 */}
          {/* <p className={styles["product-more"]}>
            <span className={styles["learn-more-purple"]}>
              {words.common_learn_more}
            </span>
          </p> */}
          {/* Learn More */}
        </section>
      )}
    </>
    
  )
}
export default ProductSupport